/*
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  SPDX-License-Identifier: MIT-0 
*/

export default {
  cognitoUserName(state: { cognitoUserName: string }): string {
    return state.cognitoUserName;
  },
  email(state: { email: string }): string {
    return state.email;
  },
  givenName(state: { givenName: string }): string {
    return state.givenName;
  },
  familyName(state: { familyName: string }): string {
    return state.familyName;
  },
  stationCode(state: { stationCode: string }): string {
    return state.stationCode;
  },
  companyName(state: { companyName: string }): string {
    return state.companyName;
  },
  title(state: { title: string }): string {
    return state.title;
  },
  department(state: { department: string }): string {
    return state.department;
  },
};
